<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <g v-if="weight === 'THIN'" mask="url(#mask-thin)">
            <path
                d="M19.4846 20.1535L13.2231 13.892C12.7231 14.3177 12.1481 14.6472 11.4981 14.8805C10.8481 15.1139 10.1949 15.2305 9.53861 15.2305C7.93694 15.2305 6.58136 14.6761 5.47186 13.5673C4.36253 12.4585 3.80786 11.1037 3.80786 9.50304C3.80786 7.90221 4.36228 6.54629 5.47111 5.43529C6.57994 4.32446 7.9347 3.76904 9.53536 3.76904C11.1362 3.76904 12.4921 4.32371 13.6031 5.43304C14.7139 6.54254 15.2694 7.89813 15.2694 9.49979C15.2694 10.1946 15.1463 10.867 14.9001 11.517C14.6539 12.167 14.3309 12.7228 13.9309 13.1843L20.1924 19.446L19.4846 20.1535ZM9.53861 14.2305C10.8654 14.2305 11.9856 13.7738 12.8991 12.8603C13.8126 11.947 14.2694 10.8268 14.2694 9.49979C14.2694 8.17279 13.8126 7.05263 12.8991 6.13929C11.9856 5.22579 10.8654 4.76904 9.53861 4.76904C8.21161 4.76904 7.09144 5.22579 6.17811 6.13929C5.26461 7.05263 4.80786 8.17279 4.80786 9.49979C4.80786 10.8268 5.26461 11.947 6.17811 12.8603C7.09144 13.7738 8.21161 14.2305 9.53861 14.2305Z"
                fill="currentColor"
            />
            <mask
                id="mask-thin"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
        </g>

        <g v-else-if="weight === 'REGULAR'" mask="url(#mask-regular)">
            <path
                d="M19.5423 20.577L13.2616 14.296C12.7616 14.7088 12.1866 15.0319 11.5366 15.2653C10.8866 15.4986 10.2141 15.6153 9.5193 15.6153C7.81014 15.6153 6.36364 15.0235 5.1798 13.84C3.99597 12.6565 3.40405 11.2103 3.40405 9.50152C3.40405 7.79285 3.9958 6.34618 5.1793 5.16152C6.3628 3.97702 7.80897 3.38477 9.5178 3.38477C11.2265 3.38477 12.6731 3.97668 13.8578 5.16051C15.0423 6.34435 15.6346 7.79085 15.6346 9.50002C15.6346 10.2142 15.5147 10.8963 15.2751 11.5463C15.0352 12.1963 14.7153 12.7616 14.3153 13.2423L20.5961 19.523L19.5423 20.577ZM9.5193 14.1155C10.8078 14.1155 11.8991 13.6683 12.7933 12.774C13.6876 11.8798 14.1348 10.7885 14.1348 9.50002C14.1348 8.21152 13.6876 7.12018 12.7933 6.22601C11.8991 5.33168 10.8078 4.88452 9.5193 4.88452C8.2308 4.88452 7.13947 5.33168 6.2453 6.22601C5.35097 7.12018 4.9038 8.21152 4.9038 9.50002C4.9038 10.7885 5.35097 11.8798 6.2453 12.774C7.13947 13.6683 8.2308 14.1155 9.5193 14.1155Z"
                fill="currentColor"
            />
            <mask
                id="mask-regular"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
        </g>

        <g v-else mask="url(#mask-fill)">
            <path
                d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z"
                fill="currentColor"
            />
            <mask
                id="mask-fill"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'search-icon',
    props: {
        width: {
            type: [String, Number],
            default: 24,
        },
        height: {
            type: [String, Number],
            default: 24,
        },
        color: {
            type: String,
            default: 'text-black',
        },
        weight: {
            type: String,
            default: 'THIN',
            validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
        },
    },
};
</script>
